import { useState } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useI18n, LANGS } from "../context/I18nContext";

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];
  const base = dark ? "text-fir hover:text-gold" : "text-ivory/90 hover:text-gold";

  return (
    <div className="relative" data-testid="language-switcher">
      <button onClick={() => setOpen(!open)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        className={`flex items-center gap-1.5 text-sm ${base} transition-colors`} data-testid="lang-toggle">
        <Globe size={16} /> <span className="hidden sm:inline">{cur.flag}</span> {cur.label} <ChevronDown size={14} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-36 bg-white rounded-xl shadow-xl border border-stone overflow-hidden z-50">
          {LANGS.map((l) => (
            <button key={l.code} data-testid={`lang-option-${l.code}`}
              onMouseDown={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2 hover:bg-ivory transition-colors ${l.code === lang ? "text-gold font-medium" : "text-fir-deep/80"}`}>
              <span>{l.flag}</span> {l.label === "IT" ? "Italiano" : l.label === "EN" ? "English" : l.label === "DE" ? "Deutsch" : "Polski"}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
